import { Loader } from '@googlemaps/js-api-loader';
import { Tween, Easing, update } from '@tweenjs/tween.js';

export const state = {
    map: null,
    markerCluster: null,
    markers: [],
    markerMap: new Map(),
    filterCategories: [],
    categoryColors: {},
    sidebarMarkers: { markers: [] },
    sidebarMarkerSet: new Set(),
    sidebarElementMap: new Map(),
    interestCount: { count: 0 },
    onlineOnlyBusinesses: { businesses: [] },
    visibleSidebarItems: new Set(),
    sidebarObserverInitialized: false,
    sidebarObserver: null,
    pendingImageLoads: new Set(),
    isAnimating: false,
    activeTween: null,
    isModalOpen: false,
    lastFocusedElement: null,
    lastViewedId: null,
    search: { isActive: false, sidebarWasOpen: false, markers: [], allResults: [], currentPage: 1 },
    vw: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
    firstOpen: true,
    params: Object.fromEntries(new URLSearchParams(window.location.search).entries()),
    Tween: Tween,
    Easing: Easing,
    TWEEN: { update }
};

export const loader = new Loader({
	apiKey: "AIzaSyDsV88LhqtDNDbMWP0p0VCgPTXJ3Txa5I8",
	region: "CA",
});

export const mapOptions = {
	center: {
		lat: 44.1628,
		lng: -77.3832,
	},
	zoom: 17,
	heading: 310,
	tilt: 65,
	mapId: '31fe421252689cc6cbdfe8c1', // Required for Vector map tiles
	mapTypeControl: false,
	streetViewControl: false,
	zoomControl: true,
	rotateControl: false,
	fullscreenControl: false,
};
